import { render } from "./KidFooter2.vue?vue&type=template&id=273d41aa&scoped=true"
import script from "./KidFooter2.vue?vue&type=script&lang=js"
export * from "./KidFooter2.vue?vue&type=script&lang=js"

import "./KidFooter2.vue?vue&type=style&index=0&id=273d41aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273d41aa"]])

export default __exports__